import { resolveInstance } from 'core/utils/composer';

import user from './descriptors/user';
import getter from './descriptors/getter';
import forker from './descriptors/forker';
import checker from './descriptors/checker';
import subscriber from './descriptors/subscriber';

const preset = [
  subscriber,
  user,
  getter,
  forker,
  checker,
];

export default function themesFactory(themes, active) {
  const state = {
    themes,
    active,
    factory: themesFactory,
  };

  return resolveInstance(preset, state);
}
